import {RouteDefinition} from '../../../routes';
import {DatabaseScreen} from './DatabaseScreen';

export const DatabaseSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/db',
        component: DatabaseScreen,
    },
];
